import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-058e3702"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "general" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Detalles de Médico")
], -1))
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos Personales")
], -1))
const _hoisted_6 = { class: "grid" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "No. ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Cédula: ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Nombre Completo: ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Dirección: ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Sexo: ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Especialidad: ", -1))
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos Profesionales")
], -1))
const _hoisted_16 = { class: "grid" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Exequatur: ", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Colegio Médico: ", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Clave DGII: ", -1))
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos de Contacto")
], -1))
const _hoisted_23 = { class: "grid" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Teléfonos.: ", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Email.: ", -1))
const _hoisted_26 = { class: "form-group" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Otros")
], -1))
const _hoisted_29 = { class: "grid" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Observaciones.: ", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Estatus.: ", -1))
const _hoisted_32 = { class: "form-group" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Estado")
], -1))
const _hoisted_35 = { class: "grid" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Facturado: ", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Pagado: ", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Retención: ", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Ingresos: ", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Reenviado: ", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Recuperado: ", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Por Cobrar: ", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Glosa: ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", null, [
      _createElementVNode("fieldset", null, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h6", null, [
              _hoisted_7,
              _createTextVNode(_toDisplayString(_ctx.currentMedico.no), 1)
            ]),
            _createElementVNode("h6", null, [
              _hoisted_8,
              _createTextVNode(_toDisplayString(_ctx.currentMedico.rncEmisor), 1)
            ]),
            _createElementVNode("h6", null, [
              _hoisted_9,
              _createTextVNode(_toDisplayString(_ctx.currentMedico.emisor), 1)
            ]),
            _createElementVNode("h6", null, [
              _hoisted_10,
              _createTextVNode(_toDisplayString(_ctx.currentMedico.direccionEmisor), 1)
            ]),
            _createElementVNode("h6", null, [
              _hoisted_11,
              _createTextVNode(_toDisplayString(_ctx.currentMedico.sexo), 1)
            ]),
            _createElementVNode("h6", null, [
              _hoisted_12,
              _createTextVNode(_toDisplayString(_ctx.currentMedico.especialidad), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("h6", null, [
              _hoisted_17,
              _createTextVNode(_toDisplayString(_ctx.currentMedico.exq), 1)
            ]),
            _createElementVNode("h6", null, [
              _hoisted_18,
              _createTextVNode(_toDisplayString(_ctx.currentMedico.cmd), 1)
            ]),
            _createElementVNode("h6", null, [
              _hoisted_19,
              _createTextVNode(_toDisplayString(_ctx.currentMedico.claveDGII), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("h6", null, [
              _hoisted_24,
              _createTextVNode(_toDisplayString(_ctx.currentMedico.telefono), 1)
            ]),
            _createElementVNode("h6", null, [
              _hoisted_25,
              _createTextVNode(_toDisplayString(_ctx.currentMedico.email), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _hoisted_28,
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("h6", null, [
              _hoisted_30,
              _createTextVNode(_toDisplayString(_ctx.currentMedico.observaciones), 1)
            ]),
            _createElementVNode("h6", null, [
              _hoisted_31,
              _createTextVNode(_toDisplayString(_ctx.currentMedico.estatus), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _hoisted_33,
          _hoisted_34,
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("h6", null, [
              _hoisted_36,
              _createTextVNode("RD$ " + _toDisplayString(_ctx.formatNumber(this.estado.facturado)), 1)
            ]),
            _createElementVNode("h6", null, [
              _hoisted_37,
              _createTextVNode("RD$ " + _toDisplayString(_ctx.formatNumber(this.estado.pagado)), 1)
            ]),
            _createElementVNode("h6", null, [
              _hoisted_38,
              _createTextVNode("RD$ " + _toDisplayString(_ctx.formatNumber(this.estado.retension)), 1)
            ]),
            _createElementVNode("h6", null, [
              _hoisted_39,
              _createTextVNode("RD$ " + _toDisplayString(_ctx.formatNumber(this.estado.ingresos)), 1)
            ]),
            _createElementVNode("h6", null, [
              _hoisted_40,
              _createTextVNode("RD$ " + _toDisplayString(_ctx.formatNumber(this.estado.reenviado)), 1)
            ]),
            _createElementVNode("h6", null, [
              _hoisted_41,
              _createTextVNode("RD$ " + _toDisplayString(_ctx.formatNumber(this.estado.recuperado)), 1)
            ]),
            _createElementVNode("h6", null, [
              _hoisted_42,
              _createTextVNode("RD$ " + _toDisplayString(_ctx.formatNumber(this.estado.porCobrar)), 1)
            ]),
            _createElementVNode("h6", null, [
              _hoisted_43,
              _createTextVNode("RD$ " + _toDisplayString(_ctx.formatNumber(this.estado.glosa)), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}